import React, { useEffect, useState } from "react";
import PageTableLayout from "../../components/Pagetablelayout";
import axios from "axios";
import { Space, Button, Modal, Form, Input, Select, Row, Col } from "antd";

export default function CountriesPage() {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingCountry, setEditingCountry] = useState(null);
  const [form] = Form.useForm();

  const token = localStorage.getItem("jwt");

  const fetchCountries = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://mdgholidaydreams.com/api/countries", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      // offerings come back as JSON string → parse
      const parsed = res.data.map(c => ({
        ...c,
        offerings: typeof c.offerings === "string" ? JSON.parse(c.offerings) : c.offerings,
      }));
      setCountries(parsed);
    } catch (err) {
      console.error("Fetch countries failed:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleAdd = () => {
    setEditingCountry(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      // offerings is already an array from Select mode="tags"
      if (!Array.isArray(values.offerings)) {
        values.offerings = [];
      }

      if (editingCountry) {
        await axios.put(`https://mdgholidaydreams.com/api/countries?id=${editingCountry.id}`, values, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      } else {
        await axios.post("https://mdgholidaydreams.com/api/countries", values, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      }

      form.resetFields();
      setIsModalVisible(false);
      setEditingCountry(null);
      fetchCountries();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingCountry(null);
    form.resetFields();
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Code", dataIndex: "code", key: "code" },
    { title: "Tag", dataIndex: "tag", key: "tag" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Image",
      dataIndex: "image_url",
      key: "image_url",
      render: url => url && <img src={url} alt="" style={{ width: 80, borderRadius: 4 }} />,
    },
    {
      title: "Offerings",
      dataIndex: "offerings",
      key: "offerings",
      render: o =>
        Array.isArray(o)
          ? o.map((item, i) => (
              <span key={i} style={{ marginRight: 6, background: "#f0f0f0", padding: "2px 6px", borderRadius: 4 }}>
                {item}
              </span>
            ))
          : "",
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: active => (active ? "Active" : "Inactive"),
    },
    { title: "Created By", dataIndex: "created_by", key: "created_by" },
    { title: "Updated By", dataIndex: "updated_by", key: "updated_by" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            onClick={() => {
              setEditingCountry(record);
              setIsModalVisible(true);
              form.setFieldsValue({
                ...record,
                offerings: Array.isArray(record.offerings) ? record.offerings : [],
              });
            }}
          >
            Edit
          </Button>
          <Button
            danger
            onClick={() =>
              axios
                .patch(`https://mdgholidaydreams.com/api/countries?id=${record.id}`, {}, {
                  headers: token ? { Authorization: `Bearer ${token}` } : {},
                })
                .then(fetchCountries)
            }
          >
            Deactivate
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTableLayout
        breadcrumb={["Admin", "Countries"]}
        title="Manage Countries"
        addButtonLabel="Add Country"
        onAdd={handleAdd}
        columns={columns}
        dataSource={countries}
        loading={loading}
        onRefresh={fetchCountries}
      />

      <Modal
        title={editingCountry ? "Edit Country" : "Add New Country"}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        width={800}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Country Name"
                rules={[{ required: true, message: "Please enter a country name" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="code"
                label="Country Code"
                rules={[{ required: true, message: "Please enter a country code" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="tag" label="Tag">
                <Input />
              </Form.Item>

              <Form.Item
                name="active"
                label="Status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value={1}>Active</Select.Option>
                  <Select.Option value={0}>Inactive</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="description" label="Description">
                <Input.TextArea rows={3} />
              </Form.Item>

              <Form.Item name="image_url" label="Image URL">
                <Input />
              </Form.Item>

              <Form.Item name="offerings" label="Offerings">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Enter offerings (press Enter after each)"
                  tokenSeparators={[","]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
